module.exports = __webpack_public_path__ + "img/R&Dstrength.c5842e3f.jpg";